<template>
  <div class="home" id="home">
    <full-page
      :options="options"
      id="homepage-fullpage"
      ref="fullpage"
      class="homepage-fullpage"
    >
      <div class="section">
        <div class="fack-bg">
          <div class="replenish" />
          <embed type="image/svg+xml" :src="home_bg" :style="styleObj" class="embed" />
        </div>
        <!-- <embed type="image/svg+xml" :src="home_bg" :style="styleObj" class="embed"/> -->
        <swiper
          ref="swiper"
          :options="swiperOptions"
          :style="styleObj"
          @slide-change-transition-end="handleSlideChangeEnd"
          @slide-change-transition-start="handleSlideChangeStart"
          class="swiper"
        >
          <swiper-slide>
            <HomeAcc />
          </swiper-slide>
          <swiper-slide>
            <HomeProduct />
          </swiper-slide>
        </swiper>
      </div>
      <div class="section">
        <HomeEcological />
      </div>
      <div class="section" id="news">
        <HomeNews />
      </div>
    </full-page>
  </div>
</template>
<script>
import HomeAcc from './home_acc.vue'
import HomeProduct from './home_product.vue'
import HomeEcological from './home_ecological.vue'
import HomeNews from './home_news.vue'
import Bus from "../../bus"
import home_bg from '@/../static/img/home/bg.svg'
import Footer from "@/components/footer.vue"
export default {
  components: { HomeAcc, HomeProduct, HomeEcological, HomeNews, Footer },
  data() {
    return {
      home_bg,
      options: {
        // 开源 GPL 项目使用此 key；商业项目需购买 license 后替换为官方提供的 key
        licenseKey: null,
        scrollBar: false,
        afterLoad: this.afterLoad,
        sectionsColor: [],
        autoScrolling: true,
        scrollHorizontally: true,
        onLeave: this.onLeave,
        css3: true,
        easingcss3: 'ease-in-out',
        verticalCentered: false,
        fitToSection: false
      },
      currentIndex: 1,
      swiperOptions: {
        direction : 'vertical',
        observer:true,
        speed:700,
        loop: false,
        mousewheel: true,
        observeParents:true,
        observeSlideChildren:true,
      },
      checkSection: 1,
      styleObj: {
        left: 0,
        bottom: 0
      },
      homeTowObj: {
        background: 'transparent'
      },
    }
  },
  mounted() {
    Bus.$emit("show-menu", false);
    this.$nextTick(() => {
      const fullpageApi = this.$refs.fullpage && this.$refs.fullpage.api
      if (!fullpageApi) return
      fullpageApi.reBuild()
      fullpageApi.setAllowScrolling(false)
      fullpageApi.setKeyboardScrolling(false)
    })
  },
  methods: {
    onLeave({ index }, destination, direction) {
      this.checkSection = destination.index + 1;
      this.busFun(destination.index < 1)
    },
    busFun(val) {
      Bus.$emit("logo-fixed-flag", val);
    },
    handleSlideChangeEnd() {
      const i = this.$refs.swiper.swiperInstance.realIndex;
      if (i == 0) {
        this.$refs.fullpage.api.setAllowScrolling(false)
        this.$refs.fullpage.api.setKeyboardScrolling(false)
      } else {
        this.$refs.fullpage.api.setAllowScrolling(true)
        this.$refs.fullpage.api.setKeyboardScrolling(true)
      }
    },
    handleSlideChangeStart() {
      const scale = document.documentElement.clientWidth / 375;
      const gap = 27 * scale;
      const i = this.$refs.swiper.swiperInstance.realIndex;
      if (i == 0) {
        this.styleObj = {
          bottom: 0,
          left: 0,
        }
      } else {
        this.styleObj = {
          bottom: `${-gap}px`,
          left: 0,
        }
      }
    },
    afterLoad(anchorLink, index) {
      if (index.index == 2 && anchorLink.index == 1) {
        // 当页面滚动到倒数第二屏时，改变页面滚动方式
        this.$refs.fullpage.api.setAutoScrolling(false);
        // 记录页面开始滚动的位置
        let start = document.documentElement.scrollTop;
        let last = 0;
        window.addEventListener('scroll', () => {
          // 获得页面实时滚动的位置
          let end = document.documentElement.scrollTop;
          // 如滚动的位置小于0，则代表页面在倒数第二屏向上滚，这个时候再改变页面的滚动方式
          if (end - start < 0) {
            this.$refs.fullpage.api.setAutoScrolling(true);
          }
        })
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('scroll', () => {
      // 获得页面实时滚动的位置
      let end = document.documentElement.scrollTop;
      // 如滚动的位置小于0，则代表页面在倒数第二屏向上滚，这个时候再改变页面的滚动方式
      if (end - start < 0) {
        this.$refs.fullpage.api.setAutoScrolling(true);
      }
    })
  }
}
</script>
<style lang="less" scoped>
.home {
  width: 100%;
  height: 100%;
  background: #F0F2F5;
  .section {
    width: 100%;
    height: 100%;
    .swiper-container {
      width: 100%;
      height: 100%;
    }
    .swiper-wrapper {
      width: 100%;
      height: 100%;
    }
    .swiper-slide {
      width: 100%;
      height: 100% !important;
    }
    .fack-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      display: flex;
      flex-direction: column;
      background: #ffffff;
      .replenish {
        flex: 1;
        background: #141686;
      }
      .embed {
        width: 100%;
        position: absolute;
        transition: 0.7s;
      }
    }
  }
  .news {
    width: 100%;
  }
  .foot {
    height: 476px !important;
    .fp-tableCell {
      height: 476px !important;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/home/index.vue